import ModalConfirm from "../../player/modal";
import styles from "./index.module.less";
import { ButtonField } from "@wk/components-react16";
import unKnownJudges from "@/assets/img/unKnownJudges.png";

const ChangeHeaderPic = ({
  src,
  isHeaderPicOpen,
  setIsHeaderPicOpen,
  changeUserHeaderPic,
  clickPicFileInput,
}) => {
  return (
    <ModalConfirm
      height="auto"
      isOpen={isHeaderPicOpen}
      onClose={() => {
        setIsHeaderPicOpen(false);
      }}
      children={
        <div className={styles["change-header-pic-box"]}>
          {src ? (
            <div className="has-header-pic-box">
              <img src={src} alt="" />

              <div className="btn-box">
                <ButtonField>
                  <button
                    type="button"
                    onClick={(e) => {
                      setIsHeaderPicOpen(false);
                      clickPicFileInput(e);
                    }}
                  >
                    更换
                  </button>
                </ButtonField>

                <ButtonField mode={"ghost"}>
                  <button
                    type="button"
                    onClick={() => {
                      setIsHeaderPicOpen(false);
                      changeUserHeaderPic("");
                    }}
                  >
                    移除
                  </button>
                </ButtonField>
              </div>
            </div>
          ) : (
            <div className="no-header-pic-box">
              <img src={unKnownJudges} alt="" />
              <div
                className="upload-box"
                onClick={(e) => {
                  setIsHeaderPicOpen(false);
                  clickPicFileInput(e);
                }}
              >
                上传图片文件
              </div>
              <div className="tip-box">
                图片尺寸需要大于100 *
                100像素，支持jpg、png、jpeg等格式，大小不能超过2MB
              </div>

              <div className="btn-box">
                <ButtonField mode={"ghost"}>
                  <button
                    type="button"
                    onClick={() => {
                      setIsHeaderPicOpen(false);
                    }}
                  >
                    返回
                  </button>
                </ButtonField>
              </div>
            </div>
          )}
        </div>
      }
      title={"头像"}
      onConfirm={() => {
        console.log("1111");
      }}
      // isConfirmLoading={}
      okText="确定"
      isFooter={false}
    />
  );
};

export default ChangeHeaderPic;
